export default __webpack_public_path__ + "static/media/metamask3.502b9db4.png";